import axios from "axios";
import config from "../constants/config";

export default {
  methods: {
    async LoadMapScripts () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.AUTH.MAP_TOKEN}`
      );

      var script1 = document.createElement("script");
      var script2 = document.createElement("script");

      script1.setAttribute(
        "src",
        `https://apis.mapmyindia.com/advancedmaps/api/${res.data.token}/map_sdk?v=3.0&layer=vector`
      );

      script2.setAttribute(
        "src",
        `https://apis.mapmyindia.com/advancedmaps/api/${res.data.token}/map_sdk_plugins`
      );

      document.head.appendChild(script1);
      document.head.appendChild(script2);

      return res.data;
    },

    async FetchGISLocationAndGroups () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.LOCATIONS}`
      );
      return res.data;
    },

    async FetchGroupDevices (groupId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.GROUP_DEVICES}?id=${groupId}`
      );
      return res.data;
    },

    async FetchLocationDevices (locationId) {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.LOCATION_DEVICES}?id=${locationId}`
      );
      return res.data;
    },


    async GetAllDevices () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_DEVICES}`
      );
      return res.data;
    },

    async LoadRTSPDevice (deviceId) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.LOAD_RTSP}`, { deviceId }
      );
      return res.data;
    },

    async StopRTSPDevice () {
      const res = await axios.post(`${config.BASE_URL}${config.API_ROUTES.DASHBOARD.STOP_RTSP}`);
      return res.data;
    },
  },
};
